import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom';

const FormEditStudyMaterial = () => {
  document.title = "Edit Study Material | Uma Classes";
  const { id } = useParams();

  const [formData, setFormData] = useState({
    title: "",
    categoryId: "",
    subcategoryId: "",
    subSubcategoryId: "",
    file: null,  // Handle new file uploads
  });
  useEffect(() => {
    const fetchCategoriesAndMaterial = async () => {
      try {
        const token = localStorage.getItem('token');

        const categoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCategories(categoriesResponse);

        // Fetch subcategories
        const subcategoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-subcategory', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubcategories(subcategoriesResponse);

        // Fetch sub-subcategories
        const subSubcategoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-subsubcategory', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubSubcategories(subSubcategoriesResponse);
        // Fetch Study Material details
        const materialResponse = await axios.get(`https://uma.aasmo.in/api/admin/get-study-material/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const materialData = materialResponse;
        setFormData({
          title: materialData.title,
          categoryId: materialData.category._id, // Set category ID
          subcategoryId: materialData.subcategory._id, // Set subcategory ID
          subSubcategoryId: materialData.subSubcategory._id, // Set sub-subcategory ID
          file: materialData.fileUrl || null,
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories or material details:", error);
        setLoading(false);
      }
    };

    fetchCategoriesAndMaterial();
  }, [id]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [subSubcategories, setSubSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");



  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value, // Handle file input
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
   
      formDataToSend.append('category', formData.categoryId);
      formDataToSend.append('subcategory', formData.subcategoryId);
      formDataToSend.append('subSubcategory', formData.subSubcategoryId);
      if (formData.file instanceof File) {
        formDataToSend.append('file', formData.file); // New file if uploaded
      }

      await axios.put(`https://uma.aasmo.in/api/admin/update-study-material/${id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      });

      setSuccessMessage("Study material updated successfully");
      setErrorMessage("");
    } catch (error) {
      console.error("Error updating study material:", error);
      setErrorMessage("Error updating study material");
      setSuccessMessage("");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Study Material" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="title" className="col-md-2 col-form-label">Title</label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter Title"
                          required
                        />
                      </div>
                    </Row>

                  
                    <Row className="mb-3">
                      <label htmlFor="file" className="col-md-2 col-form-label">Upload New Material (Optional)</label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="file"
                          id="file"
                          name="file"
                          accept=".jpeg,.jpg,.png,.pdf,.mp4" // Allowed file types
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="categoryId" className="col-md-2 col-form-label">Category</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="categoryId"
                          name="categoryId"
                          value={formData.categoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="subcategoryId" className="col-md-2 col-form-label">Subcategory</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="subcategoryId"
                          name="subcategoryId"
                          value={formData.subcategoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Subcategory</option>
                          {subcategories.map(subcategory => (
                            <option key={subcategory._id} value={subcategory._id}>
                              {subcategory.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="subSubcategoryId" className="col-md-2 col-form-label">Sub-Subcategory</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="subSubcategoryId"
                          name="subSubcategoryId"
                          value={formData.subSubcategoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Sub-Subcategory</option>
                          {subSubcategories.map(subSubcategory => (
                            <option key={subSubcategory._id} value={subSubcategory._id}>
                              {subSubcategory.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary">Save</button>
                    </div>
                  </form>
                  
                  {successMessage && <Alert color="success">{successMessage}</Alert>}
                  {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormEditStudyMaterial;
